__turbopack_context__.v({
  "actions": "PlasmicHeader-module__pxMy6G__actions",
  "actions2": "PlasmicHeader-module__pxMy6G__actions2",
  "body": "PlasmicHeader-module__pxMy6G__body",
  "bottom": "PlasmicHeader-module__pxMy6G__bottom",
  "button": "PlasmicHeader-module__pxMy6G__button",
  "desktopHeader": "PlasmicHeader-module__pxMy6G__desktopHeader",
  "desktopHeadercolor_transparent": "PlasmicHeader-module__pxMy6G__desktopHeadercolor_transparent",
  "desktopHeadercolor_white": "PlasmicHeader-module__pxMy6G__desktopHeadercolor_white",
  "divider": "PlasmicHeader-module__pxMy6G__divider",
  "fb": "PlasmicHeader-module__pxMy6G__fb",
  "features": "PlasmicHeader-module__pxMy6G__features",
  "hamburgerIcon": "PlasmicHeader-module__pxMy6G__hamburgerIcon",
  "ig": "PlasmicHeader-module__pxMy6G__ig",
  "img__dvDxu": "PlasmicHeader-module__pxMy6G__img__dvDxu",
  "img__mneaK": "PlasmicHeader-module__pxMy6G__img__mneaK",
  "img__oSjo3": "PlasmicHeader-module__pxMy6G__img__oSjo3",
  "img__pKpQ7": "PlasmicHeader-module__pxMy6G__img__pKpQ7",
  "img__rhiFu": "PlasmicHeader-module__pxMy6G__img__rhiFu",
  "img__s9WzT": "PlasmicHeader-module__pxMy6G__img__s9WzT",
  "img__zRi8V": "PlasmicHeader-module__pxMy6G__img__zRi8V",
  "li": "PlasmicHeader-module__pxMy6G__li",
  "logInButton": "PlasmicHeader-module__pxMy6G__logInButton",
  "logInButton2": "PlasmicHeader-module__pxMy6G__logInButton2",
  "logInLink": "PlasmicHeader-module__pxMy6G__logInLink",
  "logo": "PlasmicHeader-module__pxMy6G__logo",
  "logo3": "PlasmicHeader-module__pxMy6G__logo3",
  "menu": "PlasmicHeader-module__pxMy6G__menu",
  "mobileDrawer": "PlasmicHeader-module__pxMy6G__mobileDrawer",
  "mobileDrawerItem": "PlasmicHeader-module__pxMy6G__mobileDrawerItem",
  "mobileHeader2": "PlasmicHeader-module__pxMy6G__mobileHeader2",
  "mobileHeader2color_transparent": "PlasmicHeader-module__pxMy6G__mobileHeader2color_transparent",
  "mobileHeader2color_white": "PlasmicHeader-module__pxMy6G__mobileHeader2color_white",
  "nav": "PlasmicHeader-module__pxMy6G__nav",
  "navWrapper": "PlasmicHeader-module__pxMy6G__navWrapper",
  "requestDemoButton": "PlasmicHeader-module__pxMy6G__requestDemoButton",
  "requestDemoButton2": "PlasmicHeader-module__pxMy6G__requestDemoButton2",
  "right2": "PlasmicHeader-module__pxMy6G__right2",
  "root": "PlasmicHeader-module__pxMy6G__root",
  "rootcolor_transparent": "PlasmicHeader-module__pxMy6G__rootcolor_transparent",
  "rootcolor_white": "PlasmicHeader-module__pxMy6G__rootcolor_white",
  "socials": "PlasmicHeader-module__pxMy6G__socials",
  "svg___7CAku": "PlasmicHeader-module__pxMy6G__svg___7CAku",
  "svg__gMWgt": "PlasmicHeader-module__pxMy6G__svg__gMWgt",
  "svg__ifUa5": "PlasmicHeader-module__pxMy6G__svg__ifUa5",
  "svg__moabT": "PlasmicHeader-module__pxMy6G__svg__moabT",
  "svg__oZiqu": "PlasmicHeader-module__pxMy6G__svg__oZiqu",
  "svg__ooQ3Y": "PlasmicHeader-module__pxMy6G__svg__ooQ3Y",
  "svg__vEySk": "PlasmicHeader-module__pxMy6G__svg__vEySk",
  "svg__yronw": "PlasmicHeader-module__pxMy6G__svg__yronw",
  "text__aprEt": "PlasmicHeader-module__pxMy6G__text__aprEt",
  "text__hHXu6": "PlasmicHeader-module__pxMy6G__text__hHXu6",
  "text__jsmib": "PlasmicHeader-module__pxMy6G__text__jsmib",
  "text__sduxe": "PlasmicHeader-module__pxMy6G__text__sduxe",
  "th": "PlasmicHeader-module__pxMy6G__th",
  "wrapper": "PlasmicHeader-module__pxMy6G__wrapper",
  "x": "PlasmicHeader-module__pxMy6G__x",
});
